import { C } from '../constants';

export default function LoadingDots({ msg }) {
  return (
    <div style={{ textAlign:"center", padding:"28px 16px" }}>
      <div style={{ fontSize:13, color:C.soft, marginBottom:12 }}>{msg}</div>
      <div style={{ display:"flex", gap:6, justifyContent:"center" }}>
        {[0,1,2].map(i=><div key={i} style={{ width:8, height:8, borderRadius:"50%", background:C.gold2, animation:`hmapulse 1.2s ${i*0.22}s ease-in-out infinite` }}/>)}
      </div>
    </div>
  );
}
